import React, { useEffect, useState } from 'react';

const Question2 = ({ response, question, handleResponse }) => {

  const [selectedResponse, setSelectedResponse] = useState(response);

  const handleChange = (event) => {
    const value = event.target.value === 'true';
    setSelectedResponse(value);
    handleResponse(1, value);
  };

  const renderMessageBox = () => {
    if (selectedResponse === true) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <div className='message-content'>
            <p>Study Design Identified: <strong>{question.name}</strong></p>
            <br />
            <p>Requirements:</p>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <p dangerouslySetInnerHTML={{__html: question.message_html}}></p>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderRetrospectiveRadioButtons = () => {
    return (
      <div className='question-block'>
        <h5>{question.question_text}</h5>
        <input
          type="radio"
          name="retrospective"
          value="true"
          onChange={handleChange}
          checked={selectedResponse === true}
          id="retrospective_true"
        />
        <label htmlFor="retrospective_true">{question.true_response_text}</label>
        <br />
        <input
          type="radio"
          name="retrospective"
          value="false"
          onChange={handleChange}
          checked={selectedResponse === false}
          id="retrospective_false"
        />
        <label htmlFor="retrospective_false">{question.false_response_text}</label>
        <br />
        {renderMessageBox()}
      </div>
    );
  };

  return (
    <div>
      {renderRetrospectiveRadioButtons()}
    </div>
  );
};

export default Question2;